import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "form-label-wrapper form-label-width" }
const _hoisted_3 = { class: "mr-2 form-label" }
const _hoisted_4 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_5 = { class: "form-label__text" }
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = { class: "form-field-wrapper" }
const _hoisted_8 = { class: "form-row-bottom" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_10 = { class: "form-field" }
const _hoisted_11 = { class: "form-message" }
const _hoisted_12 = ["id"]
const _hoisted_13 = { class: "form-label-wrapper form-label-width" }
const _hoisted_14 = { class: "mr-2 form-label" }
const _hoisted_15 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_16 = { class: "form-label__text" }
const _hoisted_17 = { class: "form-field" }
const _hoisted_18 = { class: "form-field-wrapper" }
const _hoisted_19 = { class: "form-row-bottom" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_21 = { class: "form-field" }
const _hoisted_22 = { class: "form-message" }
const _hoisted_23 = ["id"]
const _hoisted_24 = { class: "form-label-wrapper form-label-width" }
const _hoisted_25 = { class: "mr-2 form-label" }
const _hoisted_26 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_27 = { class: "form-label__text" }
const _hoisted_28 = { class: "form-field" }
const _hoisted_29 = { class: "form-field-wrapper" }
const _hoisted_30 = { class: "form-row-bottom" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_32 = { class: "form-field" }
const _hoisted_33 = { class: "form-message" }
const _hoisted_34 = ["id"]
const _hoisted_35 = { class: "form-label-wrapper form-label-width" }
const _hoisted_36 = { class: "mr-2 form-label" }
const _hoisted_37 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_38 = { class: "form-label__text" }
const _hoisted_39 = { class: "form-field" }
const _hoisted_40 = { class: "form-field-wrapper" }
const _hoisted_41 = { class: "form-row-bottom" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_43 = { class: "form-field" }
const _hoisted_44 = { class: "form-message" }
const _hoisted_45 = ["id"]
const _hoisted_46 = { class: "form-label-wrapper form-label-width" }
const _hoisted_47 = { class: "mr-2 form-label" }
const _hoisted_48 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_49 = { class: "form-label__text" }
const _hoisted_50 = { class: "form-field" }
const _hoisted_51 = { class: "form-field-wrapper" }
const _hoisted_52 = { class: "form-row-bottom" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_54 = { class: "form-field" }
const _hoisted_55 = { class: "form-message" }
const _hoisted_56 = ["id"]
const _hoisted_57 = { class: "form-label-wrapper form-label-width" }
const _hoisted_58 = { class: "mr-2 form-label" }
const _hoisted_59 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_60 = { class: "form-label__text" }
const _hoisted_61 = { class: "form-field" }
const _hoisted_62 = { class: "form-field-wrapper" }
const _hoisted_63 = { class: "form-row-bottom" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_65 = { class: "form-field" }
const _hoisted_66 = { class: "form-message" }
const _hoisted_67 = ["id"]
const _hoisted_68 = { class: "form-label-wrapper form-label-width" }
const _hoisted_69 = { class: "mr-2 form-label" }
const _hoisted_70 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_71 = { class: "form-label__text" }
const _hoisted_72 = { class: "form-field" }
const _hoisted_73 = { class: "form-field-wrapper" }
const _hoisted_74 = { class: "form-row-bottom" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_76 = { class: "form-field" }
const _hoisted_77 = { class: "form-message" }
const _hoisted_78 = {
  key: 1,
  class: "my-6"
}
const _hoisted_79 = ["id"]
const _hoisted_80 = { class: "form-row-top" }
const _hoisted_81 = { class: "form-label-wrapper form-label-width" }
const _hoisted_82 = { class: "mr-2 form-label" }
const _hoisted_83 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_84 = { class: "form-label__text" }
const _hoisted_85 = { class: "form-field" }
const _hoisted_86 = { class: "form-field-wrapper" }
const _hoisted_87 = { class: "form-row-bottom" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_89 = { class: "form-field" }
const _hoisted_90 = { class: "form-message" }
const _hoisted_91 = {
  key: 3,
  class: "mb-2 mt-10"
}
const _hoisted_92 = { class: "form-label-wrapper form-label-width" }
const _hoisted_93 = { class: "mr-2 form-label" }
const _hoisted_94 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_95 = { class: "form-label__text" }
const _hoisted_96 = { class: "form-field" }
const _hoisted_97 = { class: "form-field-wrapper" }
const _hoisted_98 = { class: "form-row-bottom" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_100 = { class: "form-field" }
const _hoisted_101 = { class: "form-message" }
const _hoisted_102 = ["id"]
const _hoisted_103 = { class: "form-label-wrapper form-label-width" }
const _hoisted_104 = { class: "mr-2 form-label" }
const _hoisted_105 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_106 = { class: "form-label__text" }
const _hoisted_107 = { class: "form-field" }
const _hoisted_108 = { class: "form-field-wrapper" }
const _hoisted_109 = { class: "form-row-bottom" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_111 = { class: "form-field" }
const _hoisted_112 = { class: "form-message" }
const _hoisted_113 = ["id"]
const _hoisted_114 = { class: "form-label-wrapper form-label-width" }
const _hoisted_115 = { class: "mr-2 form-label" }
const _hoisted_116 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_117 = { class: "form-label__text" }
const _hoisted_118 = { class: "form-field" }
const _hoisted_119 = { class: "form-field-wrapper" }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = { class: "form-row-bottom" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_123 = { class: "form-field" }
const _hoisted_124 = { class: "form-message" }
const _hoisted_125 = ["id"]
const _hoisted_126 = { class: "form-label-wrapper form-label-width" }
const _hoisted_127 = { class: "mr-2 form-label" }
const _hoisted_128 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_129 = { class: "form-label__text" }
const _hoisted_130 = { class: "form-field" }
const _hoisted_131 = { class: "form-field-wrapper" }
const _hoisted_132 = { class: "form-row-bottom" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_134 = { class: "form-field" }
const _hoisted_135 = { class: "form-message" }
const _hoisted_136 = ["id"]
const _hoisted_137 = { class: "form-label-wrapper form-label-width" }
const _hoisted_138 = { class: "mr-2 form-label" }
const _hoisted_139 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_140 = { class: "form-label__text" }
const _hoisted_141 = { class: "form-field" }
const _hoisted_142 = { class: "form-field-wrapper" }
const _hoisted_143 = { class: "form-row-bottom" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_145 = { class: "form-field" }
const _hoisted_146 = { class: "form-message" }
const _hoisted_147 = ["id"]
const _hoisted_148 = { class: "form-label-wrapper form-label-width" }
const _hoisted_149 = { class: "mr-2 form-label" }
const _hoisted_150 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_151 = { class: "form-label__text" }
const _hoisted_152 = { class: "form-field" }
const _hoisted_153 = { class: "form-field-wrapper" }
const _hoisted_154 = { class: "form-row-bottom" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_156 = { class: "form-field" }
const _hoisted_157 = { class: "form-message" }
const _hoisted_158 = { class: "form-row mb-2" }
const _hoisted_159 = { class: "form-label-wrapper form-label-width" }
const _hoisted_160 = { class: "mr-2 form-label" }
const _hoisted_161 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_162 = { class: "form-label__text" }
const _hoisted_163 = { class: "form-field" }
const _hoisted_164 = { class: "form-field-wrapper" }
const _hoisted_165 = { class: "form-row-bottom" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_167 = { class: "form-field" }
const _hoisted_168 = { class: "form-message" }
const _hoisted_169 = { class: "form-row mb-2 w-100" }
const _hoisted_170 = { class: "form-label-wrapper form-label-width" }
const _hoisted_171 = { class: "mr-2 form-label" }
const _hoisted_172 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_173 = { class: "form-label__text" }
const _hoisted_174 = { class: "form-field" }
const _hoisted_175 = { class: "form-field-wrapper" }
const _hoisted_176 = { class: "form-row-bottom" }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_178 = { class: "form-field" }
const _hoisted_179 = { class: "form-message" }
const _hoisted_180 = ["id"]
const _hoisted_181 = { class: "form-label-wrapper form-label-width" }
const _hoisted_182 = { class: "mr-2 form-label" }
const _hoisted_183 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_184 = { class: "form-label__text" }
const _hoisted_185 = { class: "form-field" }
const _hoisted_186 = { class: "form-field-wrapper" }
const _hoisted_187 = /*#__PURE__*/_createTextVNode(" ₽ ")
const _hoisted_188 = { key: 0 }
const _hoisted_189 = { class: "form-row-bottom" }
const _hoisted_190 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_191 = { class: "form-field" }
const _hoisted_192 = { class: "form-message" }
const _hoisted_193 = { class: "form-row-bottom" }
const _hoisted_194 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_195 = { class: "form-field" }
const _hoisted_196 = { class: "form-message" }
const _hoisted_197 = { class: "form-row mb-2 w-100" }
const _hoisted_198 = { class: "form-label-wrapper form-label-width" }
const _hoisted_199 = { class: "mr-2 form-label" }
const _hoisted_200 = {
  key: 0,
  class: "form-label__asterisk"
}
const _hoisted_201 = { class: "form-label__text" }
const _hoisted_202 = { class: "form-field" }
const _hoisted_203 = { class: "form-field-wrapper form-field-wrapper_column" }
const _hoisted_204 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph" }, [
    /*#__PURE__*/_createElementVNode("span", null, " Пользователи с "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "//agroru.com/uslugi/accounts/",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "badge badge-warning" }, " PRO "),
      /*#__PURE__*/_createElementVNode("span", null, " аккаунтом ")
    ]),
    /*#__PURE__*/_createElementVNode("span", null, " – наиболее серьезная и активная часть аудитории сайта. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_pre = _resolveComponent("base-pre")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_BaseUpload = _resolveComponent("BaseUpload")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_pre, {
      hide: "",
      title: "entryData",
      data: _ctx.entryData
    }, null, 8, ["data"]),
    _createVNode(_component_base_pre, {
      hide: "",
      title: "entryDataNew",
      data: _ctx.entryDataNew
    }, null, 8, ["data"]),
    _createElementVNode("form", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["form-row mb-2", {
          'bg-light-info': _ctx.entryDataNew.type.color,
          'form-row_colored': _ctx.entryDataNew.type.color,
        }]),
        id: _ctx.entryDataNew.type.slug
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-row-top", _ctx.entryDataNew.type.toTop ? 'form-row-top_to-top' : ''])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, [
              (_ctx.entryDataNew.type.rules && _ctx.entryDataNew.type.rules.includes('required'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, " * "))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.entryDataNew.type['label']) + ": ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entryDataNew.type.options, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_radio, {
                  key: index,
                  border: "",
                  label: item['value'],
                  modelValue: _ctx.entryDataNew.type.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entryDataNew.type.value) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateField(_ctx.entryDataNew.type.slug, false)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item['label']), 1)
                  ]),
                  _: 2
                }, 1032, ["label", "modelValue"]))
              }), 128))
            ])
          ])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.entryDataNew.type.message), 1)
          ])
        ], 512), [
          [_vShow, !_ctx.entryDataNew.type.valid]
        ])
      ], 10, _hoisted_1),
      _createElementVNode("div", {
        class: _normalizeClass(["form-row mb-2", {
          'bg-light-info': _ctx.entryDataNew.name.color,
          'form-row_colored': _ctx.entryDataNew.name.color,
        }]),
        id: _ctx.entryDataNew.name.slug
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-row-top", _ctx.entryDataNew.name.toTop ? 'form-row-top_to-top' : ''])
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, [
              (_ctx.entryDataNew.name.rules && _ctx.entryDataNew.name.rules.includes('required'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, " * "))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.entryDataNew.name.label) + ": ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.entryDataNew.name.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.entryDataNew.name.value) = $event)),
                class: "w-75",
                size: "large",
                clearable: "",
                type: "text",
                "show-word-limit": "",
                placeholder: _ctx.entryDataNew.name.placeholder,
                maxlength: _ctx.entryDataNew.name.maxlength,
                onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateField(_ctx.entryDataNew.name.slug, false))),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateField(_ctx.entryDataNew.name.slug, false)))
              }, null, 8, ["modelValue", "placeholder", "maxlength"])
            ])
          ])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.entryDataNew.name.message), 1)
          ])
        ], 512), [
          [_vShow, !_ctx.entryDataNew.name.valid]
        ])
      ], 10, _hoisted_12),
      _createElementVNode("div", {
        class: _normalizeClass(["form-row mb-2", {
          'bg-light-info': _ctx.entryDataNew.description.color,
          'form-row_colored': _ctx.entryDataNew.description.color,
        }]),
        id: _ctx.entryDataNew.description.slug
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-row-top", _ctx.entryDataNew.description.toTop ? 'form-row-top_to-top' : ''])
        }, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("label", _hoisted_25, [
              (_ctx.entryDataNew.description.rules && _ctx.entryDataNew.description.rules.includes('required'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_26, " * "))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.entryDataNew.description.label) + ": ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.entryDataNew.description.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.entryDataNew.description.value) = $event)),
                class: "w-75",
                size: "large",
                clearable: "",
                rows: 8,
                type: "textarea",
                "show-word-limit": "",
                placeholder: _ctx.entryDataNew.description.placeholder,
                maxlength: _ctx.entryDataNew.description.maxlength,
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateField(_ctx.entryDataNew.description.slug, false)))
              }, null, 8, ["modelValue", "placeholder", "maxlength"])
            ])
          ])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.entryDataNew.description.message), 1)
          ])
        ], 512), [
          [_vShow, !_ctx.entryDataNew.description.valid]
        ])
      ], 10, _hoisted_23),
      _createElementVNode("div", {
        class: _normalizeClass(["form-row mb-2", {
          'bg-light-info': _ctx.entryDataNew.country.color,
          'form-row_colored': _ctx.entryDataNew.country.color,
        }]),
        id: _ctx.entryDataNew.country.slug
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-row-top", _ctx.entryDataNew.country.toTop ? 'form-row-top_to-top' : ''])
        }, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("label", _hoisted_36, [
              (_ctx.entryDataNew.country.rules && _ctx.entryDataNew.country.rules.includes('required'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, " * "))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.entryDataNew.country.label) + ": ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_el_autocomplete, {
                clearable: "",
                filterable: "",
                "trigger-on-focus": false,
                "value-key": "value",
                class: "w-75",
                placeholder: _ctx.entryDataNew.country.placeholder,
                "aria-expanded": "true",
                "fetch-suggestions": _ctx.countrySuggestions,
                maxlength: _ctx.entryDataNew.country.maxlength,
                modelValue: _ctx.entryDataNew.country.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.entryDataNew.country.value) = $event))
              }, null, 8, ["placeholder", "fetch-suggestions", "maxlength", "modelValue"])
            ])
          ])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.entryDataNew.country.message), 1)
          ])
        ], 512), [
          [_vShow, !_ctx.entryDataNew.country.valid]
        ])
      ], 10, _hoisted_34),
      _createElementVNode("div", {
        class: _normalizeClass(["form-row mb-2", {
          'bg-light-info': _ctx.entryDataNew.address.color,
          'form-row_colored': _ctx.entryDataNew.address.color,
        }]),
        id: _ctx.entryDataNew.address.slug
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-row-top", _ctx.entryDataNew.address.toTop ? 'form-row-top_to-top' : ''])
        }, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("label", _hoisted_47, [
              (_ctx.entryDataNew.address.rules && _ctx.entryDataNew.address.rules.includes('required'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_48, " * "))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.entryDataNew.address.label) + ": ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createVNode(_component_el_autocomplete, {
                clearable: "",
                filterable: "",
                "trigger-on-focus": false,
                "value-key": "value",
                class: "w-75",
                placeholder: _ctx.entryDataNew.address['placeholder'],
                "aria-expanded": "true",
                "fetch-suggestions": _ctx.addressSuggestions,
                maxlength: _ctx.entryDataNew.address['maxlength'],
                modelValue: _ctx.entryDataNew.address.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.entryDataNew.address.value) = $event)),
                onSelect: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectAddress($event, 'address'))),
                onChange: _cache[10] || (_cache[10] = ($event: any) => ([_ctx.changeAddress, _ctx.validateField(_ctx.entryDataNew.address.slug, false)])),
                onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validateField('address_id', false)))
              }, null, 8, ["placeholder", "fetch-suggestions", "maxlength", "modelValue"])
            ])
          ])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_52, [
          _hoisted_53,
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.entryDataNew.address.message), 1)
          ])
        ], 512), [
          [_vShow, !_ctx.entryDataNew.address.valid]
        ])
      ], 10, _hoisted_45),
      _createElementVNode("div", {
        class: _normalizeClass(["form-row mb-2", {
          'bg-light-info': _ctx.entryDataNew.rubric.color,
          'form-row_colored': _ctx.entryDataNew.rubric.color,
        }]),
        id: _ctx.entryDataNew.rubric.slug
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-row-top", _ctx.entryDataNew.rubric.toTop ? 'form-row-top_to-top' : ''])
        }, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("label", _hoisted_58, [
              (_ctx.entryDataNew.rubric.rules && _ctx.entryDataNew.rubric.rules.includes('required'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_59, " * "))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.entryDataNew.rubric.label) + ": ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createVNode(_component_el_cascader, {
                class: "w-75",
                clearable: "",
                filterable: "",
                props: {
                  value: 'id',
                  emitPath: false,
                  multiple: false,
                  checkStrictly: true,
                },
                options: _ctx.rubricsInitTree,
                placeholder: _ctx.entryDataNew.rubric['placeholder'],
                modelValue: _ctx.entryDataNew.rubric.value,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.entryDataNew.rubric.value) = $event)),
                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.validateField(_ctx.entryDataNew.rubric.slug, false)))
              }, null, 8, ["options", "placeholder", "modelValue"])
            ])
          ])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_63, [
          _hoisted_64,
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.entryDataNew.rubric.message), 1)
          ])
        ], 512), [
          [_vShow, !_ctx.entryDataNew.rubric.valid]
        ])
      ], 10, _hoisted_56),
      (!_ctx.propEdit)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "form-row mb-2",
            id: _ctx.entryDataNew.id.slug
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["form-row-top", _ctx.entryDataNew.id.toTop ? 'form-row-top_to-top' : ''])
            }, [
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("label", _hoisted_69, [
                  (_ctx.entryDataNew.id.rules && _ctx.entryDataNew.id.rules.includes('required'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_70, " * "))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.entryDataNew.id.label) + ": ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.entryDataNew.id.value,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.entryDataNew.id.value) = $event)),
                    class: "w-75",
                    size: "large",
                    clearable: "",
                    type: "text",
                    "show-word-limit": "",
                    maxlength: _ctx.entryDataNew.id.maxlength,
                    placeholder: _ctx.entryDataNew.id.placeholder,
                    onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.validateField(_ctx.entryDataNew.id.slug, false))),
                    onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.validateField(_ctx.entryDataNew.id.slug, false))),
                    onInput: _cache[17] || (_cache[17] = ($event: any) => ([
                  _ctx.trimOnlyNumbers3(false, _ctx.entryDataNew.id.slug),
                ]))
                  }, null, 8, ["modelValue", "maxlength", "placeholder"])
                ])
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_74, [
              _hoisted_75,
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("p", _hoisted_77, _toDisplayString(_ctx.entryDataNew.id.message), 1)
              ])
            ], 512), [
              [_vShow, !_ctx.entryDataNew.id.valid]
            ])
          ], 8, _hoisted_67))
        : _createCommentVNode("", true),
      (_ctx.entryDataNew['rubric_props'] && _ctx.entryDataNew['rubric_props'].length)
        ? (_openBlock(), _createElementBlock("h6", _hoisted_78, " Свойства рубрики "))
        : _createCommentVNode("", true),
      (_ctx.entryDataNew['rubric_props'] && _ctx.entryDataNew['rubric_props'].length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.entryDataNew['rubric_props'], (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "form-row mb-2",
              id: _ctx.entryDataNew['rubric_props'][index].slug
            }, [
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("label", _hoisted_82, [
                    (item.rules && item.rules.includes('required'))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_83, " * "))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_84, _toDisplayString(item.label) + ": ", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    (_ctx.entryDataNew['rubric_props'][index].as === 'text')
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: _ctx.entryDataNew['rubric_props'][index].value,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.entryDataNew['rubric_props'][index].value) = $event),
                          class: "w-50",
                          clearable: "",
                          size: "small",
                          minlength: _ctx.entryDataNew['rubric_props'][index]['minlength'],
                          maxlength: _ctx.entryDataNew['rubric_props'][index]['maxlength'],
                          onBlur: ($event: any) => (_ctx.validateField(index, true)),
                          onInput: ($event: any) => ([
                      _ctx.trimOnlyNumbers(true, index),
                      _ctx.trimMinMax(_ctx.entryDataNew['rubric_props'][index].min, _ctx.entryDataNew['rubric_props'][index].max, index)
                    ])
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "minlength", "maxlength", "onBlur", "onInput"]))
                      : _createCommentVNode("", true),
                    (_ctx.entryDataNew['rubric_props'][index].as === 'select')
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 1,
                          clearable: "",
                          class: "w-50",
                          size: "small",
                          modelValue: _ctx.entryDataNew['rubric_props'][index].value,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.entryDataNew['rubric_props'][index].value) = $event),
                          placeholder: _ctx.entryDataNew['rubric_props'][index].placeholder,
                          onChange: ($event: any) => (_ctx.validateField(index, true))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entryDataNew['rubric_props'][index].options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange"]))
                      : _createCommentVNode("", true),
                    (_ctx.entryDataNew['rubric_props'][index].as === 'date')
                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: 2,
                          size: "small",
                          class: "w-50",
                          type: "date",
                          modelValue: _ctx.entryDataNew['rubric_props'][index].value,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.entryDataNew['rubric_props'][index].value) = $event),
                          clearable: "",
                          format: "YYYY-MM-DD",
                          placeholder: _ctx.entryDataNew['rubric_props'][index].placeholder,
                          "disabled-date": _ctx.disabledDateFromFuture,
                          onInput: ($event: any) => ([
                      _ctx.trimOnlyNumbers(true, index),
                    ]),
                          onChange: ($event: any) => (_ctx.validateField(index, true))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled-date", "onInput", "onChange"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("p", _hoisted_90, _toDisplayString(_ctx.entryDataNew['rubric_props'][index].message), 1)
                ])
              ], 512), [
                [_vShow, !_ctx.entryDataNew['rubric_props'][index].valid]
              ])
            ], 8, _hoisted_79))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.entryDataNew.type.value === 'demand')
        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
            _createElementVNode("div", {
              class: _normalizeClass(["form-row-top", _ctx.entryDataNew.refine.toTop ? 'form-row-top_to-top' : ''])
            }, [
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("label", _hoisted_93, [
                  (_ctx.entryDataNew.refine.rules && _ctx.entryDataNew.refine.rules.includes('required'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_94, " * "))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.entryDataNew.refine.label) + ": ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", _hoisted_97, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entryDataNew.refine.options, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_radio, {
                      key: index,
                      border: "",
                      label: item.value,
                      modelValue: _ctx.entryDataNew.refine.value,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.entryDataNew.refine.value) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item['label']), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "modelValue"]))
                  }), 128))
                ])
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_98, [
              _hoisted_99,
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("p", _hoisted_101, _toDisplayString(_ctx.entryDataNew.refine.message), 1)
              ])
            ], 512), [
              [_vShow, !_ctx.entryDataNew.refine.valid]
            ])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.entryDataNew.type.value === 'demand' &&
          _ctx.entryDataNew.refine.value === true
        )
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: _normalizeClass(["form-row", {
          'bg-light-info': _ctx.entryDataNew['order_type'].color,
          'form-row_colored': _ctx.entryDataNew['order_type'].color,
        }]),
            id: _ctx.entryDataNew['order_type'].slug
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["form-row-top", _ctx.entryDataNew['order_type'].toTop ? 'form-row-top_to-top' : ''])
            }, [
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("label", _hoisted_104, [
                  (_ctx.entryDataNew['order_type'].rules && _ctx.entryDataNew['order_type'].rules.includes('required'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_105, " * "))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.entryDataNew['order_type'].label) + ": ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("div", _hoisted_108, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entryDataNew['order_type'].options, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_radio, {
                      key: index,
                      border: "",
                      label: item.value,
                      modelValue: _ctx.entryDataNew['order_type'].value,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.entryDataNew['order_type'].value) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item['label']), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "modelValue"]))
                  }), 128))
                ])
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_109, [
              _hoisted_110,
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("p", _hoisted_112, _toDisplayString(_ctx.entryDataNew['order_type'].message), 1)
              ])
            ], 512), [
              [_vShow, !_ctx.entryDataNew['order_type'].valid]
            ])
          ], 10, _hoisted_102))
        : _createCommentVNode("", true),
      (
          _ctx.entryDataNew.type.value === 'demand' &&
          _ctx.entryDataNew.refine.value === true
        )
        ? (_openBlock(), _createElementBlock("div", {
            key: 5,
            class: _normalizeClass(["form-row", {
          'bg-light-info': _ctx.entryDataNew['order_quantity'].color,
          'form-row_colored': _ctx.entryDataNew['order_quantity'].color,
        }]),
            id: _ctx.entryDataNew['order_quantity'].slug
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["form-row-top", _ctx.entryDataNew['order_quantity'].toTop ? 'form-row-top_to-top' : ''])
            }, [
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("label", _hoisted_115, [
                  (_ctx.entryDataNew['order_quantity'].rules && _ctx.entryDataNew['order_quantity'].rules.includes('required'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_116, " * "))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.entryDataNew['order_quantity'].label) + ": ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_118, [
                _createElementVNode("div", _hoisted_119, [
                  _createVNode(_component_el_input, {
                    class: "input-with-select w-75",
                    modelValue: _ctx.entryDataNew['order_quantity'].value,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.entryDataNew['order_quantity'].value) = $event)),
                    placeholder: "Введите количество",
                    onBlur: _cache[22] || (_cache[22] = ($event: any) => (_ctx.validateField(_ctx.entryDataNew['order_quantity'].slug, false))),
                    onInput: _cache[23] || (_cache[23] = ($event: any) => ([
                  _ctx.trimOnlyNumbers(false, _ctx.entryDataNew['order_quantity'].slug),
                ])),
                    type: "text",
                    maxlength: "9"
                  }, {
                    append: _withCtx(() => [
                      (
                      _ctx.selectedRubric &&
                      _ctx.selectedRubric.data &&
                      _ctx.selectedRubric.data.measure
                    )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_120, _toDisplayString(_ctx.selectedRubric.data.measure.name), 1))
                        : (_openBlock(), _createBlock(_component_el_select, {
                            key: 1,
                            modelValue: _ctx.priceMeasureId,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.priceMeasureId) = $event)),
                            placeholder: "Введите ед. изм.",
                            style: {"width":"130px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measuresList, (item, key) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: key,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_121, [
              _hoisted_122,
              _createElementVNode("div", _hoisted_123, [
                _createElementVNode("p", _hoisted_124, _toDisplayString(_ctx.entryDataNew['order_quantity'].message), 1)
              ])
            ], 512), [
              [_vShow, !_ctx.entryDataNew['order_quantity'].valid]
            ])
          ], 10, _hoisted_113))
        : _createCommentVNode("", true),
      (
          _ctx.entryDataNew.type.value === 'demand' &&
          _ctx.entryDataNew.refine.value === true
        )
        ? (_openBlock(), _createElementBlock("div", {
            key: 6,
            class: _normalizeClass(["form-row", {
          'bg-light-info': _ctx.entryDataNew['order_delivery_type'].color,
          'form-row_colored': _ctx.entryDataNew['order_delivery_type'].color,
        }]),
            id: _ctx.entryDataNew['order_delivery_type'].slug
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["form-row-top", _ctx.entryDataNew['order_delivery_type'].toTop ? 'form-row-top_to-top' : ''])
            }, [
              _createElementVNode("div", _hoisted_126, [
                _createElementVNode("label", _hoisted_127, [
                  (_ctx.entryDataNew['order_delivery_type'].rules && _ctx.entryDataNew['order_delivery_type'].rules.includes('required'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_128, " * "))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_129, _toDisplayString(_ctx.entryDataNew['order_delivery_type'].label) + ": ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_130, [
                _createElementVNode("div", _hoisted_131, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entryDataNew['order_delivery_type'].options, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_radio, {
                      key: index,
                      border: "",
                      label: item.value,
                      modelValue: _ctx.entryDataNew['order_delivery_type'].value,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.entryDataNew['order_delivery_type'].value) = $event)),
                      onBlur: _cache[25] || (_cache[25] = ($event: any) => (_ctx.validateField(_ctx.entryDataNew['order_delivery_type'].slug, false))),
                      onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.validateField(_ctx.entryDataNew['order_delivery_type'].slug, false)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item['label']), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "modelValue"]))
                  }), 128))
                ])
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_132, [
              _hoisted_133,
              _createElementVNode("div", _hoisted_134, [
                _createElementVNode("p", _hoisted_135, _toDisplayString(_ctx.entryDataNew['order_delivery_type'].message), 1)
              ])
            ], 512), [
              [_vShow, !_ctx.entryDataNew['order_delivery_type'].valid]
            ])
          ], 10, _hoisted_125))
        : _createCommentVNode("", true),
      (
          _ctx.entryDataNew.type.value === 'demand' &&
          _ctx.entryDataNew.refine.value === true &&
          _ctx.entryDataNew['order_delivery_type'].value === 'Доставка'
        )
        ? (_openBlock(), _createElementBlock("div", {
            key: 7,
            class: _normalizeClass(["form-row", {
          'bg-light-info': _ctx.entryDataNew['order_delivery_address'].color,
          'form-row_colored': _ctx.entryDataNew['order_delivery_address'].color,
        }]),
            id: _ctx.entryDataNew['order_delivery_address'].slug
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["form-row-top", _ctx.entryDataNew['order_delivery_address'].toTop ? 'form-row-top_to-top' : ''])
            }, [
              _createElementVNode("div", _hoisted_137, [
                _createElementVNode("label", _hoisted_138, [
                  (_ctx.entryDataNew['order_delivery_address'].rules && _ctx.entryDataNew['order_delivery_address'].rules.includes('required'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_139, " * "))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_140, _toDisplayString(_ctx.entryDataNew['order_delivery_address'].label) + ": ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_141, [
                _createElementVNode("div", _hoisted_142, [
                  _createVNode(_component_el_autocomplete, {
                    id: _ctx.entryDataNew['order_delivery_address'].slug,
                    clearable: "",
                    filterable: "",
                    "trigger-on-focus": false,
                    "value-key": "value",
                    class: "w-75",
                    placeholder: _ctx.entryDataNew['order_delivery_address'].placeholder,
                    "aria-expanded": "true",
                    "fetch-suggestions": _ctx.addressSuggestions,
                    maxlength: _ctx.entryDataNew['order_delivery_address'].maxlength,
                    modelValue: _ctx.entryDataNew['order_delivery_address'].value,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.entryDataNew['order_delivery_address'].value) = $event)),
                    onBlur: _cache[28] || (_cache[28] = ($event: any) => (_ctx.validateField(_ctx.entryDataNew['order_delivery_address'].slug, false))),
                    onSelect: _cache[29] || (_cache[29] = ($event: any) => (_ctx.selectAddress($event, 'order_delivery_address'))),
                    onChange: _ctx.changeAddress
                  }, null, 8, ["id", "placeholder", "fetch-suggestions", "maxlength", "modelValue", "onChange"])
                ])
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_143, [
              _hoisted_144,
              _createElementVNode("div", _hoisted_145, [
                _createElementVNode("p", _hoisted_146, _toDisplayString(_ctx.entryDataNew['order_delivery_address'].message), 1)
              ])
            ], 512), [
              [_vShow, !_ctx.entryDataNew['order_delivery_address'].valid]
            ])
          ], 10, _hoisted_136))
        : _createCommentVNode("", true),
      (
          _ctx.entryDataNew.type.value === 'demand' &&
          _ctx.entryDataNew.refine.value === true
        )
        ? (_openBlock(), _createElementBlock("div", {
            key: 8,
            class: _normalizeClass(["form-row", {
          'bg-light-info': _ctx.entryDataNew['order_payment_method'].color,
          'form-row_colored': _ctx.entryDataNew['order_payment_method'].color,
        }]),
            id: _ctx.entryDataNew['order_payment_method'].slug
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["form-row-top", _ctx.entryDataNew['order_payment_method'].toTop ? 'form-row-top_to-top' : ''])
            }, [
              _createElementVNode("div", _hoisted_148, [
                _createElementVNode("label", _hoisted_149, [
                  (_ctx.entryDataNew['order_payment_method'].rules && _ctx.entryDataNew['order_payment_method'].rules.includes('required'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_150, " * "))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.entryDataNew['order_payment_method'].label) + ": ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_152, [
                _createElementVNode("div", _hoisted_153, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entryDataNew['order_payment_method'].options, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_radio, {
                      key: index,
                      border: "",
                      label: item.value,
                      modelValue: _ctx.entryDataNew['order_payment_method'].value,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.entryDataNew['order_payment_method'].value) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item['label']), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "modelValue"]))
                  }), 128))
                ])
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_154, [
              _hoisted_155,
              _createElementVNode("div", _hoisted_156, [
                _createElementVNode("p", _hoisted_157, _toDisplayString(_ctx.entryDataNew['order_payment_method'].message), 1)
              ])
            ], 512), [
              [_vShow, !_ctx.entryDataNew['order_payment_method'].valid]
            ])
          ], 10, _hoisted_147))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_158, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-row-top", _ctx.entryDataNew.fixed.toTop ? 'form-row-top_to-top' : ''])
        }, [
          _createElementVNode("div", _hoisted_159, [
            _createElementVNode("label", _hoisted_160, [
              (_ctx.entryDataNew.fixed.rules && _ctx.entryDataNew.fixed.rules.includes('required'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_161, " * "))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_162, _toDisplayString(_ctx.entryDataNew.fixed.label) + ": ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_163, [
            _createElementVNode("div", _hoisted_164, [
              (_ctx.entryDataNew.fixed.as === 'date')
                ? (_openBlock(), _createBlock(_component_el_date_picker, {
                    key: 0,
                    class: "w-50",
                    type: "date",
                    modelValue: _ctx.entryDataNew.fixed.value,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.entryDataNew.fixed.value) = $event)),
                    clearable: "",
                    format: "YYYY-MM-DD",
                    placeholder: _ctx.entryDataNew.fixed.placeholder,
                    "disabled-date": _ctx.disabledDateFromPast,
                    onInput: _cache[32] || (_cache[32] = ($event: any) => ([
                  _ctx.trimOnlyNumbers(false, 'fixed_until'),
                ]))
                  }, null, 8, ["modelValue", "placeholder", "disabled-date"]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_165, [
          _hoisted_166,
          _createElementVNode("div", _hoisted_167, [
            _createElementVNode("p", _hoisted_168, _toDisplayString(_ctx.entryDataNew.fixed.message), 1)
          ])
        ], 512), [
          [_vShow, !_ctx.entryDataNew.fixed.valid]
        ])
      ]),
      _createElementVNode("div", _hoisted_169, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-row-top", _ctx.entryDataNew.photos.toTop ? 'form-row-top_to-top' : ''])
        }, [
          _createElementVNode("div", _hoisted_170, [
            _createElementVNode("label", _hoisted_171, [
              (_ctx.entryDataNew.photos.rules && _ctx.entryDataNew.photos.rules.includes('required'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_172, " * "))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_173, _toDisplayString(_ctx.entryDataNew.photos.label) + ": ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_174, [
            _createElementVNode("div", _hoisted_175, [
              _createVNode(_component_BaseUpload, {
                modelValue: _ctx.entryDataNew.photos.value,
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.entryDataNew.photos.value) = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_176, [
          _hoisted_177,
          _createElementVNode("div", _hoisted_178, [
            _createElementVNode("p", _hoisted_179, _toDisplayString(_ctx.entryDataNew.photos.message), 1)
          ])
        ], 512), [
          [_vShow, !_ctx.entryDataNew.photos.valid]
        ])
      ]),
      _createElementVNode("div", {
        class: "form-row mb-2 w-100",
        id: _ctx.entryDataNew.price.slug
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-row-top", _ctx.entryDataNew.price.toTop ? 'form-row-top_to-top' : ''])
        }, [
          _createElementVNode("div", _hoisted_181, [
            _createElementVNode("label", _hoisted_182, [
              (_ctx.entryDataNew.price.rules && _ctx.entryDataNew.price.rules.includes('required'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_183, " * "))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_184, _toDisplayString(_ctx.entryDataNew.price.label) + ": ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_185, [
            _createElementVNode("div", _hoisted_186, [
              _createVNode(_component_el_input, {
                clearable: "",
                modelValue: _ctx.entryDataNew.price.value,
                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.entryDataNew.price.value) = $event)),
                placeholder: _ctx.entryDataNew.price.placeholder,
                maxlength: _ctx.entryDataNew.price.maxlength,
                onInput: _cache[36] || (_cache[36] = ($event: any) => ([
                  _ctx.trimOnlyNumbers(false, _ctx.entryDataNew.price.slug),
                  _ctx.trimMultipleDots(_ctx.entryDataNew.price.slug),
                  _ctx.trimDotAtTheEnd(_ctx.entryDataNew.price.slug),
                  _ctx.trimPriceLength(_ctx.entryDataNew.price.slug),
                ])),
                onBlur: _cache[37] || (_cache[37] = ($event: any) => (_ctx.validateField(_ctx.entryDataNew.price.slug, false)))
              }, {
                prepend: _withCtx(() => [
                  _hoisted_187
                ]),
                append: _withCtx(() => [
                  (_ctx.selectedRubric && _ctx.selectedRubric.data && _ctx.selectedRubric.data.measure)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_188, _toDisplayString(_ctx.selectedRubric.data.measure.name), 1))
                    : (_openBlock(), _createBlock(_component_el_select, {
                        key: 1,
                        modelValue: _ctx.priceMeasureId,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.priceMeasureId) = $event)),
                        placeholder: "Введите ед. изм.",
                        style: {"width":"130px"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measuresList, (item, key) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: key,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder", "maxlength"])
            ])
          ])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_189, [
          _hoisted_190,
          _createElementVNode("div", _hoisted_191, [
            _createElementVNode("p", _hoisted_192, _toDisplayString(_ctx.entryDataNew.price.message), 1)
          ])
        ], 512), [
          [_vShow, !_ctx.entryDataNew.price.valid]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_193, [
          _hoisted_194,
          _createElementVNode("div", _hoisted_195, [
            _createElementVNode("p", _hoisted_196, _toDisplayString(_ctx.entryDataNew.measure.message), 1)
          ])
        ], 512), [
          [_vShow, !_ctx.entryDataNew.measure.valid]
        ])
      ], 8, _hoisted_180),
      _createElementVNode("div", _hoisted_197, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-row-top", _ctx.entryDataNew.pro.toTop ? 'form-row-top_to-top' : ''])
        }, [
          _createElementVNode("div", _hoisted_198, [
            _createElementVNode("label", _hoisted_199, [
              (_ctx.entryDataNew.pro.rules && _ctx.entryDataNew.pro.rules.includes('required'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_200, " * "))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_201, _toDisplayString(_ctx.entryDataNew.pro.label) + ": ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_202, [
            _createElementVNode("div", _hoisted_203, [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.entryDataNew.pro.value,
                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.entryDataNew.pro.value) = $event)),
                label: "Отвечать на объявление могут только пользователи с PRO аккаунтом"
              }, null, 8, ["modelValue"]),
              _hoisted_204
            ])
          ])
        ], 2)
      ])
    ])
  ]))
}